/*eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { t } from 'i18next';

const AffiliationsAwardsTab = ({
  affiliatedDoctorsHandler,
  doctorDetails,
  ...otherProps
}) => {
  const [medicalGroups, setMedicalGroups] = useState([]);
  const [affiliatedFacilities, setAffiliatedFacilities] = useState([]);
  useEffect(() => {
    if (
      doctorDetails.DoctorAfflFacilities &&
      doctorDetails.DoctorAfflFacilities.length
    ) {
      const meidicalGroupInfo = [];
      const afflFacilityInfo = [];
      doctorDetails.DoctorAfflFacilities.map((item, index) => {
        if (item.FacilityType === 'Group') {
          meidicalGroupInfo.push(item);
        } else {
          afflFacilityInfo.push(item);
        }
      });
      setMedicalGroups(meidicalGroupInfo);
      setAffiliatedFacilities(afflFacilityInfo);
    }
  }, [doctorDetails]);
  return (
    <>
      <div className="provider-professional-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.affiliations')}
          </p>
          <Col sm={12} className="p-0">
            <p className="provider-affiliation-sub-heading mb-3">
              {t('find_provider.hospitals_and_facilities')}
            </p>
            <Row>
              {affiliatedFacilities && affiliatedFacilities.length ? (
                affiliatedFacilities.map((item, index) => {
                  return (
                    <Col sm={6} className="mt-1" key={index}>
                      <p className="provider-details-sub-heading">
                        {item.FacilityName}
                      </p>
                      <p className="provider-details-data-secondary">
                        <span className="provider-details-data">
                          {item.AddressLine1 && item.AddressLine1 + ', '}
                          {item.AddressLine2 && item.AddressLine2 + ', '}
                          {item.AddressLine3 && item.AddressLine3 + ', '}
                          {item.City && item.City + ', '} <br />
                          {item.County && item.County + ', '}
                          {item.State && item.State + ', '}
                          {item.PostalCode && item.PostalCode}
                          &nbsp;|
                        </span>
                        <Button
                          onClick={() => {
                            affiliatedDoctorsHandler(item.FacilityId);
                          }}
                          variant="link"
                          className="paragraph-font secondary-2 cursor-pointer provider-location-link btn-link btn p-0 m-0 pl-2"
                        >
                          {t('find_provider.show_affiliated_doctors')}
                        </Button>
                      </p>
                    </Col>
                  );
                })
              ) : (
                <Col sm={6} className="mt-1">
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row className="m-0 p-0 pb-4">
          <Col sm={12} className="p-0">
            <p className="w-100 primary-text paragraph-font provider-affiliation-sub-heading mb-3">
              {t('find_provider.medical_group')}
            </p>
            <Row>
              {medicalGroups && medicalGroups.length ? (
                medicalGroups.map((item, index) => {
                  return (
                    <Col sm={6} className="mt-1" key={index}>
                      <p className="provider-details-sub-heading">
                        {item.FacilityName}
                      </p>
                      <p className="provider-details-data-secondary">
                        <span className="provider-details-data">
                          {item.AddressLine1 && item.AddressLine1 + ', '}
                          {item.AddressLine2 && item.AddressLine2 + ', '}
                          {item.AddressLine3 && item.AddressLine3 + ', '}
                          {item.City && item.City + ', '} <br />
                          {item.County && item.County + ', '}
                          {item.State && item.State + ', '}
                          {item.PostalCode && item.PostalCode}
                          &nbsp;|
                        </span>
                        <Button
                          onClick={() => {
                            affiliatedDoctorsHandler(item.FacilityId);
                          }}
                          variant="link"
                          className="paragraph-font secondary-2 cursor-pointer provider-location-link btn-link btn p-0 m-0 pl-2"
                        >
                          {t('find_provider.show_affiliated_doctors')}
                        </Button>
                      </p>
                    </Col>
                  );
                })
              ) : (
                <Col sm={6} className="mt-1">
                  <p className="no-data">
                    {t('find_provider.data_not_available')}
                  </p>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
      <div className="provider-facilities-information find-provider-bottom-border">
        <Row className="m-0 p-0 pt-4 pb-4">
          <p className="w-100 primary-text paragraph-font provider-details-heading">
            {t('find_provider.awards_and_recognitions')}
          </p>
          {doctorDetails.AwardsAndRecognition ? (
            <p className="provider-details-data">
              {doctorDetails.AwardsAndRecognition}
            </p>
          ) : (
            <p className="no-data">{t('find_provider.data_not_available')}</p>
          )}
        </Row>
      </div>
    </>
  );
};
export default AffiliationsAwardsTab;
